export const typeMessage = [
    { id: 1, name: 'ข่าวสาร' },
    { id: 2, name: 'การซ่อม' },
    // { id: 3, name: 'ค่านํ้า' },
    // { id: 4, name: 'ค่าไฟ' },
    { id: 5, name: 'ใบราคา/ใบเสนอราคา' },
    // { id: 6, name: 'การชำระเงิน' },
]


// WEBPACK FOOTER //
// ./src/constant/TypeMessage.js